import { IconProject, IconChart, IconBrand, IconCalendarDate } from 'assets'
import { ViewerTabTableColumn, TableCell } from 'components/viewers/ViewerTabTable/types'

export enum TotalAddRevenueColEnums {
  EVENT = 'Event',
  BRAND = 'Brand',
  PROJECT = 'Project',
  REVENUE = 'Revenue'
}

type TotalAddRevenueColumnsType = {
  [key in TotalAddRevenueColEnums]:
  ViewerTabTableColumn<TotalAddRevenueColEnums>
}
export const totalAddRevenueColumns: TotalAddRevenueColumnsType = {
  [TotalAddRevenueColEnums.EVENT]: {
    label: TotalAddRevenueColEnums.EVENT,
    icon: IconCalendarDate,
    sortable: false,
    width: '30%',
    draggable: true
  },
  [TotalAddRevenueColEnums.BRAND]: {
    icon: IconBrand,
    label: TotalAddRevenueColEnums.BRAND,
    sortable: false,
    width: '30%',
    draggable: true
  },
  [TotalAddRevenueColEnums.PROJECT]: {
    icon: IconProject,
    label: TotalAddRevenueColEnums.PROJECT,
    sortable: false,
    width: '30%',
    draggable: true
  },
  [TotalAddRevenueColEnums.REVENUE]: {
    icon: IconChart,
    label: TotalAddRevenueColEnums.REVENUE,
    sortable: true,
    width: '10%',
    style: { justifyContent: 'flex-end' }
  }
}

export type TotalAddRevenueLineInfo = {
  [key in TotalAddRevenueColEnums]: TableCell
} & {
  children?: TotalAddRevenueLineInfo[]
}
